let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("eBfrw")]).then(() => parcelRequire('3C1GW'));